import { THEME_DATA } from './chart-theme-data';
import { assign, take } from 'lodash';

export const DEFAULT_THEME_ID = 'contrast';

export const DEFAULT_SIMPLE_THEME_ID = 'green';

export function getTheme(id: string) {
  if (!hasTheme(id)) {
    return THEME_DATA.filter((theme) => theme.id === DEFAULT_THEME_ID)[0];
  }
  return THEME_DATA.filter((theme) => theme.id === id)[0];
}

export function getThemes(ids: Array<string>) {
  return THEME_DATA.filter((theme) => !!~ids.indexOf(theme.id));
}

export function getThemesAll() {
  return THEME_DATA;
}

export function hasTheme(id: string) {
  return THEME_DATA.some((theme) => theme.id === id);
}

export function getPalettes(ids: Array<string>) {
  const themePalette = (theme: any) => {
    const colorSummary = (color: string, i: number) => ({ [`color_${i}`]: color });
    const name = theme.name;
    const value = theme.id;
    const colors = take(theme.colors, 5)
      .map(colorSummary as any)
      .reduce(assign, {});

    return assign({ name, value }, colors);
  };

  return getThemes(ids).map(themePalette);
}

export function getThumbPalette(id: string) {
  if (!hasTheme(id)) {
    return null;
  }
  const theme = getTheme(id);
  const colors = theme.colors;
  const thumbColors = theme.thumb_colors;

  return [colors[thumbColors[0]], colors[thumbColors[1]]];
}
